var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ams-ad is-flex is-justify-content-center",attrs:{"id":"camptocamp_htd"}})
}
var staticRenderFns = []

export { render, staticRenderFns }